<div class="account">
  <div class="account-header">
      <a class="account-header-back back-button" (click)="onGoBack()">
          <i class="fa-solid fa-chevron-left"></i>
          <div class="back text">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</div>
      </a>

      <div class="account-header-logo" (click)="goToMenu()">
          <img
              [src]="companyLogo()"
              (error)="getHowdyLogo()"
              [class.not-howdy]="!isHowdyLogo"
              class="logo"
              alt="logo"
          >
            <p class="text">{{ 'WebApp.v1.Shared.AwarenessByHowdy' | translate }}</p>
      </div>
  </div>

  <div class="account-content">
    <div class="account-content-action">
        <app-pill
            class="pill-mini"
            [class.expanded]="pillExpanded"
        >
            <app-feature-pill-menu
                #pillMenu
                class="pill-menu"
                [pillMini]="true"
                (expandedChange)="pillExpanded = $event"
            ></app-feature-pill-menu>
        </app-pill>
    </div>

    <div class="account-content-header">
        <div class="account-content-header-title">{{ title | translate }}</div>
        <div class="account-content-header-name">{{ subTitle | translate }}</div>
    </div>

    <form class="account-content-container form" [formGroup]="accountForm" [class.hidden]="activeContent() !== 'form'">
        <div class="account-grid">
            <div class="account-grid-item email" [class.active]="activeGridItem() === accountItemEnum.Email">
                <button type="button" class="cancel-btn" (click)="resetEmailField()">{{ 'WebApp.v1.Shared.Buttons.Cancel' | translate }}</button>
                <input
                    #emailInput
                    type="text"
                    formControlName="email"
                    placeholder="{{ 'WebApp.v1.Account.Email' | translate }}"
                    class="account-input"
                    (click)="showButtons(accountItemEnum.Email, account()?.changeEmailEnabled)"
                    (focus)="showButtons(accountItemEnum.Email, account()?.changeEmailEnabled)"
                    [readOnly]="!account()?.changeEmailEnabled"
                    autocomplete="off"
                />
                @if (account()?.changeEmailEnabled) {
                <i class="fa fa-pen edit-icon" (click)="emailInput.focus()"></i>
                }
                <button
                    type="button"
                    class="save-btn"
                    [disabled]="!accountForm || !accountForm.get('email')?.valid || accountForm.get('email')?.value === account()?.email"
                    (click)="changeEmail()"
                >{{ 'WebApp.v1.Shared.Buttons.Save' | translate }}</button>
                <div class="account-grid-item-info">
                    <div class="account-grid-item-info-icon">i</div>
                    <div class="account-grid-item-info-text">{{ 'WebApp.v1.Account.EmailActivationLink' | translate }}</div>
                </div>
            </div>

            <div class="account-grid-item password" [class.active]="activeGridItem() === accountItemEnum.Password" [style.display]="isSsoAccount ? 'none' : 'flex'">
                <input
                    #passwordInput
                    type="password"
                    formControlName="password"
                    placeholder="{{ 'WebApp.v1.Account.Password' | translate }}"
                    class="account-input"
                    (click)="showButtons(accountItemEnum.Password, account()?.changePinEnabled, true)"
                    (focus)="showButtons(accountItemEnum.Password, account()?.changePinEnabled, true)"
                    [readOnly]="!account()?.changePinEnabled"
                />
                @if (account()?.changePinEnabled) {
                    <i class="fa fa-pen edit-icon" (click)="passwordInput.focus()"></i>
                    <div
                        class="change-password"
                        [class.visible]="activeGridItem() === accountItemEnum.Password"
                        [class.response]="changePasswordResponse() || changePasswordError()"
                    >
                        @if (changePasswordResponse()?.status === 200) {
                            <i class="fa fa-check"></i>
                            <div class="account-grid-item-info-text password">{{ 'WebApp.v1.Account.PasswordSuccessfullyChanged' | translate }}</div>
                        } @else if (changePasswordError()) {
                            <i class="fa fa-times"></i>
                            <div class="account-grid-item-info-text password">{{ changePasswordError()?.error }}</div>
                        } @else {
                            <div class="account-grid-item">
                                <input
                                    #currentPassword
                                    type="password"
                                    class="account-input"
                                    placeholder="{{ 'WebApp.v1.Account.CurrentPassword' | translate }}"
                                    (input)="checkPasswords()"
                                >
                            </div>
                            <div class="account-grid-item">
                                <input #newPassword type="password" class="account-input" placeholder="{{ 'WebApp.v1.Account.NewPassword' | translate }}" (input)="checkPasswords()">
                            </div>
                            <div class="account-grid-item">
                                <input #confirmPassword type="password" class="account-input" placeholder="{{ 'WebApp.v1.Account.ConfirmNewPassword' | translate }}" (input)="checkPasswords()">
                            </div>
        
                            <div class="change-password-buttons">
                                <button
                                    class="button back"
                                    [disabled]="changingPassword"
                                    [class.wait-cursor]="changingPassword"
                                    (click)="resetPasswordFields()"
                                >
                                    {{ 'WebApp.v1.Shared.Buttons.Cancel' | translate }}
                                </button>
                                @if (areAllPasswordsFilled()) {
                                    <button
                                        class="button save"
                                        [disabled]="changingPassword"
                                        [class.wait-cursor]="changingPassword"
                                        (click)="changePassword()"
                                    >
                                        {{ 'WebApp.v1.Shared.Buttons.Save' | translate }}
                                    </button>
                                }
                            </div>
                        }
                    </div>
                }
            </div>

            <div class="account-grid-item phone" [class.active]="activeGridItem() === accountItemEnum.Phone">
                <button type="button" class="cancel-btn phone" (click)="resetPhoneField()">{{ 'WebApp.v1.Shared.Buttons.Cancel' | translate }}</button>
                <input
                    #phoneInput
                    type="text"
                    formControlName="phone"
                    placeholder="{{ 'WebApp.v1.Account.PhoneNumber' | translate }}"
                    class="account-input"
                    [class.error]="isPhoneControlInvalid"
                    (click)="showButtons(accountItemEnum.Phone, account()?.changePhoneEnabled)"
                    (focus)="showButtons(accountItemEnum.Phone, account()?.changePhoneEnabled)"
                    [readOnly]="!account()?.changePhoneEnabled"
                />
                @if (account()?.changePhoneEnabled) {
                    <i class="fa fa-pen edit-icon" (click)="phoneInput.focus()"></i>
                }
                <button
                    type="button"
                    class="save-btn phone"
                    [disabled]="!accountForm || !accountForm.get('phone')?.valid || account()?.phonenumber === accountForm.get('phone')?.value"
                    (click)="changePhoneNumber()"
                >{{ 'WebApp.v1.Shared.Buttons.Save' | translate }}</button>
            </div>

            @if (departmentOptions.length > 0) {
                <div class="account-grid-item select">
                    <app-select
                        formControlName="division"
                        [title]="'WebApp.v1.Account.MyTeams' | translate"
                        [options]="departmentOptions"
                        padding="24px 20px"
                        [selectionEnabled]="false">
                    </app-select>
                </div>
            } @else {
                <div class="account-grid-item">
                    <div class="no-departments">{{ 'WebApp.v1.Account.NoDepartment' | translate }}</div>
                </div>
            }
        </div>
    </form>

    @if (activeContent() === 'about') {
        <div class="account-content-container" [class.hidden]="activeContent() !== 'about'">
            <div class="content-wrapper">
                <div class="content" [innerHTML]="'WebApp.v1.Account.About' | translate | markdown"></div>
            </div>
        </div>
    }

    @if (activeContent() === 'declaration') {
        <div class="account-content-container" [class.hidden]="activeContent() !== 'declaration'">
            <div class="content-wrapper">
                @if (declarationContent() === 'revoke') {
                    <i class="fa-solid fa-ban"></i>
                    <div class="content" [innerHTML]="'WebApp.v1.Account.Consent.Revoke.Text' | translate | markdown"></div>
                    <div class="declaration-buttons">
                        <button class="button back" (click)="declarationContent.set('')">{{ 'WebApp.v1.Shared.Buttons.Cancel' | translate }}</button>
                        <button class="button transparent red" (click)="rejectTermsOfService()">{{ 'WebApp.v1.Account.RevokeDeclaration' | translate }}</button>
                    </div>
                } @else {
                    <div class="content" [innerHTML]="declarationText"></div>
                }
            </div>
        </div>
    }

    @if (activeContent() === 'confirmation') {
        <div class="account-content-container">
            <div class="content-wrapper">
                <div class="content">
                    <div class="circle">
                        <i class="fa-solid fa-check"></i>
                    </div>
                </div>
            </div>
        </div>
    }
</div>

<div class="account-content-footer">
    @if (activeContent() === 'form') {
        <button class="button transparent red" (click)="onLogout()">{{ 'WebApp.v1.Shared.Buttons.Logout' | translate}}</button>
    } @else if (activeContent() === 'about') {
        <button class="button back" (click)="backToForm()">{{ 'WebApp.v1.Shared.Buttons.Back' | translate }}</button>
    } @else if ((activeContent() === 'declaration' || waitingForAction) && declarationContent() !== 'revoke') {
        <div class="declaration-buttons">
            <app-button
                class="button back"
                [label]="'WebApp.v1.Shared.Buttons.Back' | translate"
                backgroundColor="#2DADC8"
                [fontSize]="17"
                [disabled]="waitingForAction"
                [waitCursor]="waitingForAction"
                (click)="backToForm()"
            ></app-button>
            <app-button
                class="button"
                [label]="'WebApp.v1.Account.ResendDeclaration' | translate"
                backgroundColor="transparent"
                border="1px solid #57DF8E"
                textColor="#000"
                [fontSize]="17"
                [disabled]="waitingForAction"
                [waitCursor]="waitingForAction"
                (click)="resendTermsOfService()"
            ></app-button>
            <app-button
                class="button"
                [label]="'WebApp.v1.Account.RevokeDeclaration' | translate"
                backgroundColor="transparent"
                border="1px solid #C53333"
                textColor="#000"
                [fontSize]="17"
                [disabled]="waitingForAction"
                [waitCursor]="waitingForAction"
                (click)="declarationContent.set('revoke')"
            ></app-button>
        </div>
    }
    <div class="account-content-footer-links">
        <a (click)="showContent('about')">{{ 'WebApp.v1.Account.AboutThisApp' | translate }}</a>
        <a (click)="showContent('declaration')">{{ 'WebApp.v1.Account.DeclarationOfConsent' | translate }}</a>
    </div>
</div>